export const LOGIN = '/login';
export const SIGNUP = '/register';
export const LOGOUT = '/logout';
export const USERINFO = '/userinfo';
export const ACTIONS = '/dockerController';
export const INSTALLWORLDPRESS = '/install-wordpress';
export const INSTALLMSSQL = '/install-mssql';
export const INSTALLMYSQL = '/install-mysql';
export const INSTALLMONGODB = '/install-mongodb';
export const INSTALLTRAIDSERVER = '/install-traidserver';
export const INSTALLVITAGIRCRM = '/install-vitagircrm';
export const ADDDOMAIN = '/adddomain';
export const PAY = '/pay';
